var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.818V2H8.5v3.818H30zm0 11.636v-7.272H8.5v7.272H30zM29.59 0a2.909 2.909 0 012.91 2.91v14.544a2.91 2.91 0 01-2.91 2.91H9.228a2.91 2.91 0 01-2.909-2.91V2.91A2.899 2.899 0 019.228 0H29.59zM2.5 24h22.727v2.182H3.41A2.91 2.91 0 01.5 23.272v-16h2V24z",
    fill: "currentColor"
  })));
}

export default SvgCardIcon;